import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import { CancelSubscriptionConfirmDialog } from 'client/shared/components';

@inject('artistStore', 'userStore')
@observer
class SubRow extends Component {

	state = {
		confirmOpen: false
	}

	render () {
		const { artist, createdAt, currentPeriodEnd, userStore, subscriptionId } = this.props;
		const classList = ['grid-x', 'align-left', 'song-row'];
		const canCancel = !_.isNil(subscriptionId) && subscriptionId !== '';

		if (_.isUndefined(artist)) {
			return null;
		}

		return (
			<div className={ classList.join(' ') }>
				<div className="cell small-1">
					<div className="song-row-counter">
					</div>
				</div>

				<div className="cell small-3">
					<div
						className="inline"
						ref={ (node) => this.songTitleRef = node }
					>
						{ artist.name }
					</div>
				</div>

				<div className="cell small-3">
					{ new Date(parseInt(createdAt) * 1000).toLocaleDateString() }
				</div>

				<div className="cell small-3 text-center">
					{ new Date(parseInt(currentPeriodEnd) * 1000).toLocaleDateString() }
				</div>

				<div className="cell small-2 text-right">
					{ canCancel && (
						<button
							data-ta="cancel-subscription"
							className="button alert small margin-0"
							disabled={ userStore.isLoading }
							onClick={ this.handleCancelClick }
						>
							Cancel
						</button>
					) }
				</div>

				{ canCancel && (
					<CancelSubscriptionConfirmDialog
						isOpen={ this.state.confirmOpen }
						artistName={ artist.name }
						onConfirm={ this.handleConfirmCancel }
						onClose={ this.handleDismissConfirm }
					/>
				) }
			</div>
		);
	}

	@autobind
	handleCancelClick () {
		this.setState({ confirmOpen: true });
	}

	@autobind
	handleDismissConfirm () {
		this.setState({ confirmOpen: false });
	}

	@autobind
	async handleConfirmCancel () {
		const { subscriptionId, userStore } = this.props;
		try {
			await userStore.cancelSubscription(subscriptionId);
		} finally {
			this.setState({ confirmOpen: false });
		}
	}
}

export default SubRow;
